import type { NoDataProps } from "./types";

export function NoData({ msg, className = `flex justify-center w-full` }: NoDataProps) {
	return (
		<div className={`${className} text-center py-12`}>
			<p className="text-lg font-semibold text-gray-600 mb-2">{msg}</p>
		</div>
	);
}
